import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription, DrawerFooter } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FeedbackSheet = ({
  open,
  onOpenChange,
  scope,
  feedback,
  onFeedbackChange,
  onSubmit,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  scope: "all" | string;
  feedback: string;
  onFeedbackChange: (v: string) => void;
  onSubmit: () => void;
}) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>{scope === "all" ? "Regenerate matchups" : "Regenerate narrative"}</DrawerTitle>
          <DrawerDescription>
            {scope === "all"
              ? "Give feedback, then rewrite every narrative. Pairings stay as they are."
              : "Give feedback on this narrative, then rewrite it."}
          </DrawerDescription>
        </DrawerHeader>
        <div className="space-y-4 px-4 pb-2">
          <div className="space-y-1.5">
            <Label>Feedback</Label>
            <Textarea
              placeholder="e.g. shorter, end with a question"
              value={feedback}
              onChange={(e) => onFeedbackChange(e.target.value)}
              rows={3}
            />
          </div>
        </div>
        <DrawerFooter>
          <Button
            className="w-full font-semibold"
            onClick={() => {
              onOpenChange(false);
              onSubmit();
            }}
          >
            {scope === "all" ? "Regenerate" : "Regenerate narrative"}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default FeedbackSheet;
